<template>
  <div class="big">
    <div class="page_title">短信推送管理</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="between">
          <div class="searchbox">
            <div class="item">
              <span>短信内容</span>
              <el-input
                v-model="sms_content"
                placeholder="请输入短信内容"
                style="width: 300px; margin-left: 10px"
                @change="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>创建时间</span>
              <el-date-picker
                v-model="dateTime"
                type="daterange"
                range-separator="~"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="search"
                clearable
                style="width: 225px; margin-left: 10px"
              ></el-date-picker>
            </div>
            <div class="item">
              <span>发送周期</span>
              <el-select
                v-model="sms_cycle"
                clearable
                placeholder="请选择"
                style="margin-left: 10px"
                @change="getList"
              >
                <el-option label="仅本次" :value="1"></el-option>
                <el-option label="每天" :value="2"></el-option>
                <el-option label="每周" :value="3"></el-option>
                <el-option label="每月" :value="4"></el-option>
              </el-select>
            </div>
            <div class="item">
              <span>状态</span>
              <el-select
                v-model="status"
                clearable
                placeholder="请选择"
                style="margin-left: 10px"
                @change="getList"
              >
                <el-option label="正常" :value="1"></el-option>
                <el-option label="已停止" :value="2"></el-option>
                <el-option label="已发送完成" :value="3"></el-option>
              </el-select>
              <el-button
                type="info"
                style="
                  background-color: #eceff2;
                  color: #747981;
                  margin-left: 10px;
                "
                @click="search"
                >查询</el-button
              >
            </div>
          </div>

          <el-button
            type="primary"
            @click="addMsgPush"
            style="width: 120px"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1289') : false
            "
            >新增推送</el-button
          >
        </div>

        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column label="接收人员">
              <template slot-scope="scope">
                {{ scope.row.people_num_str }}
              </template>
            </el-table-column>
            <el-table-column label="发送周期" prop="send_time_str">
            </el-table-column>
            <el-table-column
              label="短信内容"
              prop="sms_content"
              width="400"
            ></el-table-column>
            <el-table-column label="短信签名" prop="sms_sign"></el-table-column>
            <el-table-column label="成功人数" prop="send_num" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.send_num">{{ scope.row.send_num }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
            ></el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.is_stop == 0 && scope.row.next_time"
                  >正常</span
                >
                <span v-if="scope.row.next_time && scope.row.is_stop == 0"
                  >(下次发送时间:{{ scope.row.next_time }})</span
                >
                <span v-if="scope.row.is_stop" style="color: #e53528"
                  >已停止</span
                >
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  @click="stopMsg(scope.row.sms_task_id)"
                  type="text"
                  v-if="scope.row.next_time && scope.row.is_stop == 0"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1287')
                      : false
                  "
                  >停止</el-button
                >
                <el-button
                  @click="toEdit(scope.row.sms_task_id)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1290')
                      : false
                  "
                  v-if="scope.row.next_time && scope.row.is_stop == 0"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  @click="toDetail(scope.row.sms_task_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1286')
                      : false
                  "
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin: 20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 详情弹窗 -->
    <el-dialog
      title="详情"
      :visible.sync="smsdata"
      width="700px"
      :close-on-click-modal="false"
    >
      <div style="padding: 20px">
        <div style="text-align: left; margin-bottom: 16px">
          <span>手机号</span>
          <el-input
            v-model="phone"
            style="width: 120px; margin: 0 15px 0 8px"
            @change="searchSms"
            size="medium"
          ></el-input>
          <span>发送时间</span>
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="~"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            style="width: 225px; margin: 0 10px 0 8px"
            size="medium"
            @change="searchSms"
          ></el-date-picker>
          <el-button
            type="info"
            style="background-color: #eceff2; color: #747981"
            size="medium"
            @click="searchSms"
            >查询</el-button
          >
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="smsData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="手机号"
              prop="phone"
              width="150"
            ></el-table-column>
            <el-table-column
              label="短信内容"
              prop="sms_content"
            ></el-table-column>
            <el-table-column label="发送时间" prop="send_time" width="150">
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="doctorSizeChange"
            @current-change="doctorCurrentChange"
            :current-page="smsPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="smsSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="smsNum"
            style="margin: 20px 0 0"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import _ from "lodash";
import dayjs from "dayjs";
export default {
  data() {
    return {
      sms_content: "",
      dateTime: "",
      sms_cycle: "",
      status: "",
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      addnotice: false,
      phone: "",
      date: [],
      smsData: [],
      smsPage: 1,
      smsSize: 10,
      smsNum: 0,
      smsdata: false,
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        sms_content: this.sms_content,
        sms_cycle: this.sms_cycle,
        status: this.status,
        start_time: this.dateTime ? this.dateTime[0] : "",
        end_time: this.dateTime ? this.dateTime[1] : "",
        page: this.currentPage,
        pageNumber: this.pagesize,
      };
      this.axios.post("platform/patient/platformSmsTask", data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.create_time = dayjs
              .unix(item.create_time)
              .format("YYYY-MM-DD HH:mm");
            item.next_time = item.next_time
              ? dayjs.unix(item.next_time).format("YYYY-MM-DD HH:mm")
              : "";
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    // 暂停发送短信
    stopMsg(sms_task_id) {
      let data = {
        sms_task_id: sms_task_id,
        is_stop: 1,
      };
      this.axios
        .post("platform/patient/stopPlatformSmsTask", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("该短信推送已停止");
            this.getList();
          }
        });
    },
    // 发送短信记录列表
    toDetail(sms_task_id) {
      this.sms_task_id = sms_task_id;
      let data = {
        sms_task_id: this.sms_task_id,
        phone: this.phone,
        page: this.smsPage,
        pageNumber: this.smsSize,
      };
      if (this.date && this.date.length > 0) {
        data.start_time = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.end_time = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      this.axios
        .post("platform/patient/platformSmsTaskLog", data)
        .then((res) => {
          if (res.code == 0) {
            this.smsData = res.data.list.map((item) => {
              item.send_time = dayjs
                .unix(item.send_time)
                .format("YYYY-MM-DD HH:mm");
              return item;
            });
            this.smsNum = res.data.total;
            this.smsdata = true;
          }
        });
    },

    //每页数据的条数
    doctorSizeChange(size) {
      this.smsSize = size;
      this.toDetail(this.sms_task_id);
    },
    //当前第几页
    doctorCurrentChange(currentPage) {
      this.smsPage = currentPage;
      this.toDetail(this.sms_task_id);
    },
    searchSms() {
      this.smsPage = 1;
      this.toDetail(this.sms_task_id);
    },
    addMsgPush() {
      this.$router.push("addmessage");
    },
    toEdit(sms_task_id) {
      this.$router.push({
        path: "editmessage",
        query: { sms_task_id },
      });
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 0px;
  .item {
    margin-right: 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
  }
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  width: 500px;
  padding-top: 20px;
  text-align: left;
}
</style>
